import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import { VerticalNav } from 'hhsoig-design-system-core'
import { Eligibility } from './eligibility'
import { Identity } from './identity'
import { Process } from './process'
import { Report } from './report'
import { scrollToTop } from '../../utilities'
import { routePaths as routes } from '../../utilities/routePaths'
import { withDocTitle } from '../../components/withDocTitle'
import css from './overview.module.css'

const DocTitle = 'Report Whistleblower Retaliation'

export class Overview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedNavId: props.match.params.id || 'report'
    }
  }

  onNavClick = (event, id) => {
    const routeComponent = !id || id === '' || id === 'report' ? '' : `/${id}`
    this.props.history.push(`${routes.whistleblower.base}${routeComponent}`)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname != this.props.location.pathname) {
      scrollToTop()
    }
    if (prevProps.match.params.id != this.props.match.params.id) {
      this.setState({ selectedNavId: this.props.match.params.id || 'report' })
    }
  }

  render() {
    return (
      <div
        className={`ds-l-row ${css.hhsMobileWrapReverse}`}
        data-testid="start-complaint"
      >
        <div className="ds-l-sm-col--12 ds-l-md-col--3">
          <VerticalNav
            selectedId={this.state.selectedNavId}
            onLinkClick={this.onNavClick}
            items={[
              {
                id: 'report',
                label: 'Report whistleblower retaliation',
                url: 'javascript:void(0)'
              },
              {
                id: 'eligibility',
                label: 'Eligibility',
                url: 'javascript:void(0)'
              },
              {
                id: 'process',
                label: 'How the complaint process works',
                url: 'javascript:void(0)'
              },
              {
                id: 'identity',
                label: 'Your identity',
                url: 'javascript:void(0)'
              }
            ]}
          />
        </div>
        <main className="ds-l-sm-col--12 ds-l-md-col--9">
          <Route exact path={routes.whistleblower.base} component={Report} />
          <Route
            exact
            path={routes.whistleblower.eligibility}
            component={Eligibility}
          />
          <Route
            exact
            path={routes.whistleblower.process}
            component={Process}
          />
          <Route
            exact
            path={routes.whistleblower.identity}
            component={Identity}
          />
        </main>
      </div>
    )
  }
}

export default withRouter(withDocTitle(Overview, DocTitle))
